import React from 'react';

import AiAgentIcon from '@atlaskit/icon/core/ai-agent';
import AiSparkleIcon from '@atlaskit/icon/core/ai-sparkle';
import CheckCircleIcon from '@atlaskit/icon/core/check-circle';
import CompassIcon from '@atlaskit/icon/core/compass';
import PersonAvatarIcon from '@atlaskit/icon/core/person-avatar';
import StarStarredIcon from '@atlaskit/icon/core/star-starred';

import {
	ALL_AGENTS_CATEGORY_ID,
	TEMPLATES_CATEGORY_ID,
	RECOMMENDED_CATEGORY_ID,
	STARRED_AGENTS_CATEGORY_ID,
	VERIFIED_AGENTS_CATEGORY_ID,
	YOUR_AGENTS_CATEGORY_ID,
} from './categoryIds';
import { RecommendedSkeleton } from './components/RecommendedSkeleton';
import { YourAgentsSkeleton } from './components/YourAgentsSkeleton';
// eslint-disable-next-line import/extensions
import { defaultAgentResultsEntryPoint } from './entrypoints/default/defaultAgentResults.entrypoint';
import { messages as recommendedMessages } from './entrypoints/recommended/messages';
// eslint-disable-next-line import/extensions
import { recommendedAgentResultsEntryPoint } from './entrypoints/recommended/recommendedAgentResults.entrypoint';
import { messages as templatesMessages } from './entrypoints/templates/messages';
import { templateResultsEntryPoint } from './entrypoints/templates/templateResults.entrypoint';
import { yourAgentResultsEntryPoint } from './entrypoints/your-agents/yourAgentResults.entrypoint';
import { messages } from './messages';
import type { BrowseAgentCategory, CategoryEntryPoint, SkeletonProps } from './types';
import { createCardListSkeleton } from './utils/createCardListSkeleton';

export const DEFAULT_CATEGORIES: readonly BrowseAgentCategory[] = [
	{
		id: RECOMMENDED_CATEGORY_ID,
		name: recommendedMessages.recommendedAgentsCategory,
		entrypoint: recommendedAgentResultsEntryPoint as CategoryEntryPoint,
		icon: AiSparkleIcon,
		skeleton: ({ testId }: SkeletonProps): React.JSX.Element => (
			<RecommendedSkeleton testId={testId} />
		),
	},
	{
		id: ALL_AGENTS_CATEGORY_ID,
		name: messages.allAgentsCategory,
		entrypoint: defaultAgentResultsEntryPoint,
		icon: AiAgentIcon,
		skeleton: createCardListSkeleton({ count: 6 }),
	},
	{
		id: STARRED_AGENTS_CATEGORY_ID,
		name: messages.starredCategory,
		entrypoint: defaultAgentResultsEntryPoint,
		icon: StarStarredIcon,
		skeleton: createCardListSkeleton({ count: 6 }),
	},
	{
		id: YOUR_AGENTS_CATEGORY_ID,
		name: messages.yourAgentsCategory,
		entrypoint: defaultAgentResultsEntryPoint,
		icon: PersonAvatarIcon,
		skeleton: createCardListSkeleton({ count: 6 }),
	},
	{
		id: VERIFIED_AGENTS_CATEGORY_ID,
		name: messages.verifiedCategory,
		entrypoint: defaultAgentResultsEntryPoint,
		icon: CheckCircleIcon,
		skeleton: createCardListSkeleton({ count: 6 }),
	},
];

export const UPLIFT_DEFAULT_CATEGORIES: readonly BrowseAgentCategory[] = [
	{
		id: RECOMMENDED_CATEGORY_ID,
		name: recommendedMessages.recommendedAgentsCategory,
		entrypoint: recommendedAgentResultsEntryPoint as CategoryEntryPoint,
		icon: AiSparkleIcon,
		skeleton: RecommendedSkeleton,
	},
	{
		id: ALL_AGENTS_CATEGORY_ID,
		name: messages.allAgentsCategory,
		entrypoint: defaultAgentResultsEntryPoint,
		icon: AiAgentIcon,
		skeleton: createCardListSkeleton({ count: 6 }),
	},
	{
		id: YOUR_AGENTS_CATEGORY_ID,
		name: messages.yourAgentsCategory,
		entrypoint: yourAgentResultsEntryPoint,
		icon: PersonAvatarIcon,
		skeleton: YourAgentsSkeleton,
	},
	{
		id: VERIFIED_AGENTS_CATEGORY_ID,
		name: messages.verifiedCategory,
		entrypoint: defaultAgentResultsEntryPoint,
		icon: CheckCircleIcon,
		skeleton: createCardListSkeleton({ count: 6 }),
	},
	{
		id: TEMPLATES_CATEGORY_ID,
		name: templatesMessages.templatesCategory,
		entrypoint: templateResultsEntryPoint as CategoryEntryPoint,
		icon: CompassIcon,
		skeleton: createCardListSkeleton({ count: 12, showHeading: true }),
	},
];
